import { FormLabel, Text } from "@chakra-ui/react";
import React from "react";
import Colors from "../../assets/colors/Colors";

const GrubLabel = props => {
    if (props.requiredLabel) {
      return (
        <FormLabel
        color={Colors.posTextInfo} fontSize={"0.94rem"}
        fontWeight={undefined !== props.fontWeight ? props.fontWeight : 300}>
          {props.name}
          <Text as="span" color={Colors.errorColor}>*</Text>
        </FormLabel>
      );
    } else if (props.label) {
      return( 
          <FormLabel color={Colors.posTextInfo} fontSize={"0.94rem"}
          fontWeight={undefined !== props.fontWeight ? props.fontWeight : 300}>
            {props.name}
          </FormLabel>
      );
    }
};

export default GrubLabel;
